export default __webpack_public_path__ + "static/media/img2.679eb509.png";